import { useEffect } from 'react';
import usePrevious from './usePrevious';

/**
 * This hook accepts a single boolean and fires the callback when the boolean goes from
 * 'true' to 'false'. This is useful for triggering events when an IO call is finished.
 */
const useOnDone = (cb: () => void, dep: boolean | null | undefined) => {
  const prevVal = usePrevious(dep);
  useEffect(() => {
    if (!!prevVal && !dep) {
      cb();
    }
  }, [cb, dep, prevVal]);
};

// **** Export **** //

export default useOnDone;
